import { CSSProperties } from 'react';

export function mergeCellStyles(common: CSSProperties = {}, specific: CSSProperties = {}): CSSProperties {
  return { ...common, ...specific };
}
